import { FC } from 'react';
import { IoAddOutline, IoCheckmark } from 'react-icons/io5';

import { CompanyProfile, PermissionCompany } from 'models';

import { ConnectProfileButton } from 'components/company-profile/components/ConnectProfileButton';
import { PartnerTeaser } from 'components/company-profile/components/PartnerTeaser';
import { ProfileRow, ProfileRowCarousel } from 'components/company-profile/components/ProfileRow';
import { useProfilePermission } from 'components/company-profile/hooks/use-profile-permission';
import { Section } from 'components/section/Section';
import { useIndustryCategories } from 'hooks/use-industry-categories';

const Partners: FC<{
    company: CompanyProfile;
    partners: CompanyProfile['partners'];
}> = ({ company, partners }) => {
    const { subCategories } = useIndustryCategories();
    const canEdit = useProfilePermission(PermissionCompany.EDIT);

    if (!partners?.length) return null;

    const categoryNames = (categoryIds: (string | null | undefined)[] = []) =>
        categoryIds
            .map((categoryId) => subCategories.find((subcategory) => subcategory.id === categoryId)?.name)
            .filter(Boolean)
            .join(', ');

    return (
        <Section title="Our Professional Network" id="partners">
            <ProfileRowCarousel dense>
                {partners.map((partner) => (
                    <PartnerTeaser
                        key={partner.id}
                        partner={partner}
                        category={categoryNames(partner.categories ?? [])}
                    />
                ))}

                {!canEdit && (
                    <ConnectProfileButton
                        key="connect"
                        company={company}
                        trigger={({ onClick, isConnected }) => (
                            <ProfileRow
                                size="lg"
                                dashed
                                leading={isConnected ? <IoCheckmark /> : <IoAddOutline />}
                                title={isConnected ? 'In your network' : 'Add as partner'}
                                meta={`Show ${company.name} in your professional network`}
                                onClick={onClick}
                            />
                        )}
                    />
                )}
            </ProfileRowCarousel>
        </Section>
    );
};

export { Partners };
